"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  font-family: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background: ", ";\n  font-family: ", ";\n  width: ", ";\n  height: ", ";\n  touch-action: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SketchWrapper = (0, _styledComponents.default)('div')(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grey['200'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.fontFamily;
}, function (_ref3) {
  var w = _ref3.w;
  return w;
}, function (_ref4) {
  var h = _ref4.h;
  return h;
});
var PlaceholderWrapper = (0, _styledComponents.default)('div')(_templateObject2(), function (_ref5) {
  var w = _ref5.w;
  return w;
}, function (_ref6) {
  var h = _ref6.h;
  return h;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.grey['600'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.fontFamily;
});

var Sketchfield =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Sketchfield, _React$Component);

  function Sketchfield(props) {
    var _this;

    _classCallCheck(this, Sketchfield);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sketchfield).call(this, props));
    _this.state = {
      isEmpty: true,
      pen: 'up',
      penCoords: [0, 0],
      ctx: null
    };

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          lineWidth = _this$props.lineWidth,
          value = _this$props.value;
      var canvas = _this.canvas.current;
      var ctx = canvas.getContext('2d'); // adapt canvas to parent size

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      ctx.fillStyle = 'transparent';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.lineWidth = lineWidth;

      _this.setState({
        ctx: ctx
      });

      if (value) _this.drawImage(value, ctx);
    };

    _this.componentDidUpdate = function (_ref9) {
      var prevValue = _ref9.value;
      var value = _this.props.value;
      if (prevValue === value) return;
      value ? _this.drawImage(value, _this.state.ctx) : _this.clear();
    };

    _this.onPenDown = function (e) {
      var rect = e.target.getBoundingClientRect();
      var offsetX = e.nativeEvent.targetTouches ? e.nativeEvent.targetTouches[0].clientX - rect.left : e.nativeEvent.offsetX;
      var offsetY = e.nativeEvent.targetTouches ? e.nativeEvent.targetTouches[0].clientY - rect.top : e.nativeEvent.offsetY;

      _this.setState({
        pen: 'down',
        penCoords: [offsetX, offsetY]
      });
    };

    _this.onPenUp = function () {
      var _this$state = _this.state,
          isEmpty = _this$state.isEmpty,
          pen = _this$state.pen;
      var onChange = _this.props.onChange;
      var canvas = _this.canvas.current;

      if (pen === 'down') {
        _this.setState({
          pen: 'up'
        });

        if (!isEmpty) onChange(canvas.toDataURL('image/png'));
      }
    };

    _this.drawImage = function (value, ctx) {
      var img = new Image();
      var canvas = _this.canvas.current;

      img.onload = function () {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        _this.setState({
          isEmpty: false
        });
      };

      img.src = value;
    };

    _this.clear = function () {
      var ctx = _this.state.ctx;
      var _this$props2 = _this.props,
          lineWidth = _this$props2.lineWidth,
          onChange = _this$props2.onChange;
      var canvas = _this.canvas.current;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'transparent';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.lineWidth = lineWidth;

      _this.setState({
        isEmpty: true
      });

      onChange(null);
    };

    _this.draw = function (e) {
      var _this$state2 = _this.state,
          pen = _this$state2.pen,
          ctx = _this$state2.ctx,
          penCoords = _this$state2.penCoords;
      var _this$props3 = _this.props,
          lineWidth = _this$props3.lineWidth,
          lineColor = _this$props3.lineColor;

      if (pen === 'down') {
        _this.setState({
          isEmpty: false
        });

        ctx.beginPath();
        ctx.lineWidth = lineWidth;
        ctx.lineCap = 'round';
        ctx.strokeStyle = lineColor;
        ctx.moveTo(penCoords[0], penCoords[1]);
        var rect = e.target.getBoundingClientRect();
        var offsetX = e.nativeEvent.targetTouches ? e.nativeEvent.targetTouches[0].clientX - rect.left : e.nativeEvent.offsetX;
        var offsetY = e.nativeEvent.targetTouches ? e.nativeEvent.targetTouches[0].clientY - rect.top : e.nativeEvent.offsetY;
        ctx.lineTo(offsetX, offsetY);
        ctx.stroke();

        _this.setState({
          penCoords: [offsetX, offsetY]
        });
      }
    };

    _this.canvas = _react.default.createRef();
    return _this;
  }

  _createClass(Sketchfield, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          width = _this$props4.width,
          height = _this$props4.height,
          placeholder = _this$props4.placeholder;
      var isEmpty = this.state.isEmpty;
      return _react.default.createElement(SketchWrapper, {
        w: width,
        h: height
      }, _react.default.createElement("canvas", {
        ref: this.canvas,
        onMouseMove: this.draw,
        onTouchStart: this.onPenDown,
        onTouchMove: this.draw,
        onTouchEnd: this.onPenUp,
        onTouchCancel: this.onPenUp,
        onMouseDown: this.onPenDown,
        onMouseUp: this.onPenUp,
        onMouseLeave: this.onPenUp
      }), isEmpty && _react.default.createElement(PlaceholderWrapper, {
        w: width,
        h: height
      }, _react.default.createElement(_Icon.default, {
        name: "touch_app",
        style: {
          display: 'block'
        }
      }), placeholder && _react.default.createElement("span", null, placeholder)));
    }
  }]);

  return Sketchfield;
}(_react.default.Component);

Sketchfield.defaultProps = {
  width: '1024px',
  height: '768px',
  lineWidth: 5,
  lineColor: 'black',
  placeholder: null,
  value: null
};
var _default = Sketchfield;
exports.default = _default;